// api.js

import axiosInstance from '../axiosInstance'

export const supplierClientMapService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post('/supplier-client-map', data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  fetch: async (client_id, supplier, limit = 10, skip = 0) => {
    try {
      let api_query = `/supplier-client-map?$populate=client&$populate=supplier&$limit=${limit}&$skip=${skip}&$sort[createdAt]=-1`
      if (client_id) {
        api_query += `&client=${client_id}`
      }

      if (supplier) {
        api_query += `&supplier=${supplier}`
      }
      const response = await axiosInstance.get(api_query)
      return response.data
    } catch (error) {
      throw error
    }
  },

  edit: async (id, data) => {
    try {
      let response = await axiosInstance.patch(`/supplier-client-map/${id}`, data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/supplier-client-map/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}
